// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB0000000000000000000000000000000",
  authDomain: "kriech-b2b40.firebaseapp.com",
  databaseURL: "https://kriech-b2b40.firebaseio.com",
  projectId: "kriech-b2b40",
  storageBucket: "kriech-b2b40.appspot.com",
  messagingSenderId: "110070092451175205682",
  appId: "1:110070092451175205682:web:0000000000000000000000",
};

const app = initializeApp(firebaseConfig);
const database = getFirestore(app);

export default database;
